import { render, staticRenderFns } from "./DistributionDialog.vue?vue&type=template&id=7f7f303a&scoped=true&"
import script from "./DistributionDialog.vue?vue&type=script&lang=ts&"
export * from "./DistributionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DistributionDialog.vue?vue&type=style&index=0&id=7f7f303a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7f303a",
  null
  
)

export default component.exports